import React from 'react';
import JasonFile from "./formLangfields.json";
import { useState, useEffect } from "react";
import { Dropdown, Form } from "react-bootstrap";
import jwt_decode from "jwt-decode";
import axios from "axios";
import useRecorder from "../utils/useRecorder.js";
import { useNavigate } from "react-router-dom";
import { Microphone, Stop, SignOut, Pause, ArrowClockwise, Record, CaretLeft, Check } from 'phosphor-react';
import mlj from "../helper/images/mlj.png";
import moe_logo from "../helper/images/moe_logo.png";
import anu_logo from "../helper/images/anuvadini_logo.png"

export default function EditActPage() {
    const navigate = useNavigate();
    const [removeClick, setRemoveClick] = useState();
    const [isLogin, setIsLogin] = useState(false);
    const [selectLang, setLang] = useState();
    const [keywords, setKeywords] = useState([]);
    const [recorderName, setRecorderName] = useState();
    const [index, setIndex] = useState();
    const [fullData, setFullData] = useState([]);
    const [blurName, setBlurName] = useState(false);
    const [blurKeyword, setBlurKeyword] = useState(false);
    const [blurAct, setBlurAct] = useState([]);
    const [blurMeaning, setBlurMeaning] = useState([]);
    const [Role, SetRole] = useState();
    const [usrID, SetUsrID] = useState();
    const [category, setCategory] = useState('');
    const [act, setAct] = useState('');
    const [eve, SetEve] = useState();
    const [audioURL, isRecording, startRecording, stopRecording, pause, setPause, resume, setResume, setIsRecording, setReset] = useRecorder();

    let langId = localStorage.getItem('editlanguage');

    const [inputList, setinputList] = useState([{
        ["_id"]: "",
        Act_id: "",
        [JasonFile[1][langId]]: ""
    }]);

    useEffect(() => {
        const lang = localStorage.getItem("editlanguage");
        setLang(lang);
        let isLogin = localStorage.getItem("legalIsLogin");
        setIsLogin(isLogin);
        const token = localStorage.getItem("legaltoken");
        if (token) {
            const usrRole = jwt_decode(token).role
            const usrID = jwt_decode(token).user_id
            SetUsrID(usrID)
            SetRole(usrRole);
        }
        const editactData = localStorage.getItem("editactData");
        let newData = JSON.parse(editactData);
        setFullData(newData[0])
        let arr = [];
        newData[0]?.Act?.map((x) => {
            if (x.Act_id || x[JasonFile[2][selectLang]]) {
                arr.push(x)
            }
        })
        if (arr.length > 0) {
            setinputList(arr);
        }

    }, []);

    // Voice to Text for Speaker Function //
    React.useEffect(() => {
        const fetchText = async () => {
            let fileName = `aud.wav`;
            let fd = new FormData();
            const output = await axios({ method: "get", url: audioURL, responseType: "blob" });
            let files = new File([output.data], fileName, { type: "audio/wav" });
            fd.append("file", files);
            fd.append("language", selectLang);
            axios.post("https://voiceapi.aicte-india.org/voice-to-text", fd)
                .then(async (res) => {
                    const textResponse = res.data;
                    let NewData = { ...inputList }
                    if (recorderName == "meaning") {
                        let temp = eve;
                        temp.target.value = textResponse.data;
                        temp.target.name = JasonFile[2][selectLang];
                        HandleChange(temp, index);
                        HandleBlurCheck(index, recorderName)
                    }
                    if (recorderName == "keyword") {
                        let key = textResponse.data;
                        setKeywords([...keywords, key])
                    }
                    if (recorderName == 'Name') {
                        setAct(textResponse.data)
                        setBlurName(true)
                    }
                });
        };
        if (audioURL !== undefined) {
            fetchText();
        }
    }, [audioURL]);
    // Voice to Text for Speaker Function //

    const HandleChange = (e, i) => {
        let variable = e.target.name;
        let value = e.target.value;
        let items = [...inputList];
        items[i][variable] = value;
        setinputList(items);
    };

    const handleremove = (index) => {
        const list = [...inputList];
        list.splice(index, 1);
        setinputList(list);
    };

    const handleaddclick = () => {
        setinputList([
            ...inputList,
            {
                ["_id"]: "",
                Act_id: "",
                [JasonFile[1][selectLang]]: ""
            },
        ]);
        setBlurAct([...blurAct, false])
        setBlurMeaning([...blurMeaning, false])
    };

    const handleKeyPress = (e) => {
        if (e.key == 'Enter') {
            setKeywords([...keywords, e.target.value])
        }
    }

    const removeKeyword = (ind) => {
        let temp = [...keywords]
        temp.splice(ind, 1)
        setKeywords(temp)
    }

    useEffect(() => {
        removeKeyword(removeClick)
    }, [removeClick])

    const submitRecord = () => {
        const Act = inputList;
        fullData.Act = inputList;
        fullData[JasonFile[6][selectLang]] = keywords;
        if (Role == 'admin' || Role == 'validator') {
            fullData[JasonFile[4][localStorage.getItem("editlanguage")]] = true
            fullData[JasonFile[5][localStorage.getItem("editlanguage")]] = usrID
        }
        axios.post(process.env.REACT_APP_BASE_URL + 'update-glossary', fullData, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${localStorage.getItem('legaltoken')}`
            },
        })
            .then(res => {
                if (res.data.status == 'success') {
                    if (Role == 'admin' || Role == 'validator') {
                        alert('Thank you for  submission')
                    }
                    else {
                        const postData = {
                            user_id: usrID,
                            language: localStorage.getItem("editlanguage") ? localStorage.getItem("editlanguage") : 'en-IN',
                            act_id: fullData._id
                        }
                        axios.post(process.env.REACT_APP_BASE_URL + 'verify/submitRequest', postData, {
                            headers: {
                                "Content-Type": "application/json",
                                "Authorization": `Bearer ${localStorage.getItem('legaltoken')}`
                            },
                        })
                            .then(res => {
                                alert('Thank you, Your data entry has been submitted for the approval')
                            })
                            .catch(err => { console.log(err) })
                    }
                    localStorage.removeItem('editactData');
                    localStorage.removeItem('editlanguage');
                    navigate('/lawdictionary/list');
                }
            })
            .catch(err => {
                console.log(err)
            })
    };

    // Login and Logout Function //
    const handleLogout = () => {
        localStorage.removeItem("legalIsLogin");
        localStorage.removeItem("legaltoken");
        navigate("/lawdictionary");
    };
    const handleLogin = () => {
        navigate("/login");
    };
    // Login and Logout Function //

    const HandleBlurCheck = (i, field) => {
        if (field == 'act') {
            let temp = blurAct;
            temp[i] = true;
            setBlurAct(temp);
        } else {
            let temp = blurMeaning;
            temp[i] = true;
            setBlurMeaning(temp);
        }
    };

    const HandleDelete = (id) => {
        let post = { _id: id };
        axios.post(process.env.REACT_APP_BASE_URL + 'remove-glossary', post, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${localStorage.getItem('legaltoken')}`
            },
        })
            .then(res => {
                alert('Data Deleted');
                navigate('/lawdictionary/home');
                navigate(0);
            })
            .catch(err => { console.log(err) }
            )
    }

    const handleNameChange = (e, field) => {
        let temp = fullData;
        temp[field] = e.target.value;
        setFullData(temp);
    }

    const HandleBackButton = () => {
        localStorage.removeItem("editactData");
        localStorage.removeItem("editlanguage");
        navigate('/lawdictionary/list')
    }

    useEffect(() => {
        setKeywords(fullData?.[JasonFile[6][selectLang]]);
    }, [fullData])

    useEffect(() => {

    }, [keywords])
    return (
        <>
            <div className="topDivLogin searchList ">
                <header className="headerLst">
                    <div className="container mainSrchDiv">
                        <div className="mainSrchDivIn">
                            <div className="row align-items-center">
                                <div className="logoarea col-12 col-sm-12 col-md-12 col-lg-9">
                                    <div className="d-flex justify-content-start flex-wrap align-items-center">
                                        <div className="listLogo">
                                            <a href="https://anuvadini.aicte-india.org/">
                                                <img src={anu_logo} width="210px" />
                                            </a>
                                            <a>
                                                <img src={mlj} alt="" width="200px" style={{ marginLeft: 10 }} />
                                            </a>
                                            <a href="">
                                                <img src={moe_logo} alt="" style={{ marginLeft: 10, }} width="120px" />
                                            </a>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12 col-sm-12 col-md-12 col-lg-3">
                                    <div className="d-flex justify-content-end align-items-center phonecenter">
                                        <button className="feedbackSpn h-auto w-auto mr-3" style={{ height: 36, }} onClick={() => { navigate('/lawdictionary') }}>
                                            Home
                                        </button>
                                        {isLogin == "true" ? (
                                            <>
                                                <div className="d-flex justify-content-end buttonmargin">
                                                    <div className="wrapper signout">
                                                        <button className="button w-auto" onClick={() => handleLogout()}><b><SignOut size={32} /></b>
                                                        </button>
                                                    </div>
                                                </div>
                                            </>) : (<>
                                                <div className="wrapper">
                                                    <button className="button w-auto" onClick={() => handleLogin()} > <b>Login</b></button>
                                                </div>
                                            </>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </header>
            </div>
            <div className="container">
                <div className="feedbackform newact ">
                    <div className='d-flex justify-content-between w-100'>
                        <p style={{ color: 'blue', textDecoration: "underline", marginTop: 20, }} onClick={() => HandleBackButton()}><CaretLeft size={20} /> Back</p>
                        {Role === 'admin' || Role === 'validator' ? <>
                            <div className="wrapper delete w-auto">
                                <button className="button w-auto mr-0" onClick={e => HandleDelete(fullData._id)}><b>Delete</b></button>
                            </div>
                        </> : <></>}
                    </div>
                    <div className='row'>
                        <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xxl-6 mb-3">
                            <label>Select Language</label>
                            <Dropdown className="text-start w-100 form-control" disabled>
                                <Dropdown.Toggle className="selectmenu text-start p-relative w-100" variant="default">
                                    {selectLang ? JasonFile[0][selectLang] : "Select Language"}
                                </Dropdown.Toggle>
                                {/* <Dropdown.Menu>
                                    {Object.entries(JasonFile[0]).map((res, i) => {
                                        return (
                                            <Dropdown.Item value={res[0]} onClick={(e) => setLang(res[0])} key={i} >
                                                {res[1]}
                                            </Dropdown.Item>
                                        );
                                    })}
                                </Dropdown.Menu> */}
                            </Dropdown>
                        </div>
                        <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xxl-6 mb-3">
                            <label>Select Category</label>
                            <Form.Select aria-label="Default select example" className='form-control' disabled>
                                <option value="Criminal law" onClick={(e) => { setCategory(e.target.value) }}>Criminal law</option>
                                <option value="Civil law" onClick={(e) => { setCategory(e.target.value) }}>Civil law</option>
                                <option value="Common law or case law or Judicial precedent or judge-made law" onClick={(e) => { setCategory(e.target.value) }}>Common law or case law or Judicial precedent or judge-made law</option>
                                <option value="Statutory law" onClick={(e) => { setCategory(e.target.value) }}>Statutory law</option>
                            </Form.Select>
                        </div>

                        <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xxl-12 mb-3">
                            <label>Name (Example - Act Name, Skill, Education)</label>
                            <input type="text" name="searchQuery" className="form-control" value={fullData[JasonFile[1][selectLang]]} onChange={(e) => { handleNameChange(e, JasonFile[1][selectLang]) }} />
                        </div>

                        <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xxl-12 mb-3 position-r">
                            <label>Keyword</label>
                            <Form.Control type="text" name="keywords" className="form-control" onKeyDown={(e) => { (handleKeyPress(e)); setBlurKeyword(true) }} />
                            <div className='fromGroup schema quill'>
                                {isRecording && recorderName == 'keyword' ?
                                    <React.Fragment>
                                        <button className="stopbutton startbutton" onClick={stopRecording} disabled={!isRecording}>
                                            <Stop size={32} weight="fill" />
                                        </button>
                                        {pause != false ?
                                            <>
                                                <button className="stopbutton startbutton" onClick={() => { setPause(false); setResume(true) }}><Record size={32} weight="fill" /></button>
                                                <button className="stopbutton startbutton" onClick={() => { }} disabled={!isRecording}><ArrowClockwise size={32} weight="bold" /></button>
                                            </>
                                            :
                                            <><button className="stopbutton startbutton" onClick={() => { setPause(true) }}><Pause size={20} weight="fill" /></button>
                                                {Text ? <button className="stopbutton startbutton" onClick={() => { }} disabled={!isRecording}><ArrowClockwise size={20} /></button> : ""}
                                            </>
                                        }
                                    </React.Fragment>
                                    :
                                    <button className="startbutton" onClick={e => { setRecorderName('keyword'); startRecording(); }} disabled={isRecording}>
                                        <Microphone size={20} weight="fill" />
                                    </button>
                                }
                            </div>
                            {Role != "user" && blurKeyword == true ? <>
                                <div className='check'>
                                    <Check size={25} color="#2fd824" weight="light" />
                                </div>
                            </> : ""}
                            <div className='removetext'>
                                {keywords?.map((it, ind) => (
                                    <>
                                        <p>{it} <span onClick={() => { setRemoveClick(ind) }}>X</span></p>
                                        {/* </div> */}
                                    </>
                                ))}
                            </div>
                        </div>
                    </div>

                    {inputList?.map((x, i) => {
                        return (
                            <>
                                <ul className="row job-supplement-attributes">
                                    <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xxl-6 mb-3">
                                        <label>ID (Example Act ID)</label>
                                        <Form.Control type="text" value={x.Act_id} name="Act_id" className="form-control" onChange={(e) => { HandleChange(e, i); HandleBlurCheck(i, 'act') }} />
                                        {Role != "user" && blurAct[i] == true ? <>
                                            <div className='check'>
                                                <Check size={25} color="#2fd824" weight="light" />
                                            </div>
                                        </> : ""}
                                    </div>

                                    <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xxl-6 mb-3 position-r">
                                        <label>Meaning / Defination</label>
                                        <Form.Control as="textarea" rows={8} name={JasonFile[2][selectLang]} value={x[JasonFile[2][selectLang]]} className="textarea" onChange={(e) => { HandleChange(e, i); HandleBlurCheck(i, 'meaning') }} />
                                        <div className='fromGroup'>
                                            {isRecording && recorderName == 'meaning' ?
                                                <React.Fragment>
                                                    <button className="stopbutton startbutton" onClick={stopRecording} disabled={!isRecording}>
                                                        <Stop size={32} weight="fill" />
                                                    </button>
                                                    {pause != false ?
                                                        <>
                                                            <button className="stopbutton startbutton" onClick={() => { setPause(false); setResume(true) }}><Record size={32} weight="fill" /></button>
                                                            <button className="stopbutton startbutton" onClick={() => { }} disabled={!isRecording}><ArrowClockwise size={32} weight="bold" /></button>
                                                        </>
                                                        :
                                                        <><button className="stopbutton startbutton" onClick={() => { setPause(true) }}><Pause size={20} weight="fill" /></button>
                                                            {Text ? <button className="stopbutton startbutton" onClick={() => { }} disabled={!isRecording}><ArrowClockwise size={20} /></button> : ""}
                                                        </>
                                                    }
                                                </React.Fragment>
                                                :
                                                <button className="startbutton" onClick={e => { SetEve(e); setIndex(i); setRecorderName('meaning'); startRecording(); }} disabled={isRecording}>
                                                    <Microphone size={20} weight="fill" />
                                                </button>
                                            }
                                        </div>
                                        {Role != "user" && blurMeaning[i] == true ? <>
                                            <div className='check'>
                                                <Check size={25} color="#2fd824" weight="light" />
                                            </div>
                                        </> : ""}
                                    </div>
                                </ul>

                                <div className="d-flex justify-content-end addlistul">
                                    {inputList.length - 1 == i && (
                                        <button className="btn btn-primary" onClick={handleaddclick}>
                                            <i className="fa fa-plus"></i> Add
                                        </button>
                                    )}
                                    {inputList.length !== 1 && i > 0 && (
                                        <button className="btn btn-danger ml-3" onClick={() => handleremove(i)}>
                                            <i class="fa fa-times" aria-hidden="true"></i> X
                                        </button>
                                    )}
                                </div>
                            </>
                        );
                    })}

                </div>
                <div className="text-center d-flex justify-content-center mb-5">
                    <button type="button" onClick={() => { submitRecord() }} className="feedbackSpn h-auto w-auto btn btn-success p-3 btn-lg" >
                        Submit
                    </button>
                </div>
            </div>
        </>
    )
}